import {FC} from 'react';
import cn from 'classnames';
import styles from './StepProgress.module.css';

type Props = {
	currentStep: number;
	totalSteps: number;
	className?: string;
};

export const StepProgress: FC<Props> = ({currentStep, totalSteps, className}) => (
	<div
		className={cn(styles.root, className)}
		role="progressbar"
		aria-valuenow={currentStep + 1}
		aria-valuemin={1}
		aria-valuemax={totalSteps}
	>
		{Array.from({length: totalSteps}, (_, index) => (
			<span
				key={index}
				className={cn(
					styles.segment,
					index < currentStep && styles.segmentCompleted,
					index === currentStep && styles.segmentCurrent,
				)}
			/>
		))}
	</div>
);
